/* global jQuery COMPONENTS */

COMPONENTS.ComponentHero = (function ($) {
  function ComponentHero () {
    this.$component = $('[data-ecs-component="component-hero"]')
    this.$plyrElem = this.$component.find('[data-ecs-components-control="hero-plyr"]')
    this.$sliderElem = this.$component.find('[data-ecs-components-control="hero-slider"]')
    this.$marketSearch = this.$component.find('[data-ecs-element="hero-market-search"]')
    this.$marketSearchSubmit = this.$marketSearch.find('[data-ecs-components-control="submit"]')
    this.$marketSearchSelect = this.$marketSearch.find('[data-ecs-components-control="nice-select"]')

    if (this.$plyrElem) {
      this.aspectRatio = ''
      if (typeof this.$plyrElem.attr('data-ecs-aspect-ratio') !== 'undefined' && this.$plyrElem.attr('data-ecs-aspect-ratio') !== false) {
        this.aspectRatio = this.$plyrElem.attr('data-ecs-aspect-ratio')
      }
    }

    if (this.$sliderElem) {
      const utility = new COMPONENTS.Utility()
      this.slidesToDisplay = 1
      this.sliderVars = utility.getSliderVars(this.slidesToDisplay)
    }
  }

  ComponentHero.prototype.initSlider = function () {
    this.$sliderElem.slick(this.sliderVars)
  }

  ComponentHero.prototype.initVideo = function () {
    const component = this
    var plyrSettings = {
      autopause: false,
      autoplay: true,
      captions: {
        active: false,
        language: 'auto',
        update: false
      },
      clickToPlay: true,
      controls: ['play'],
      fullscreen: {
        enabled: false,
        fallback: true,
        iosNative: false
      },
      hideControls: false,
      keyboard: {
        focused: true,
        global: false
      },
      loadSprite: true,
      loop: {
        active: true
      },
      muted: true,
      volume: 0,
      ratio: component.aspectRatio,
      tooltips: {
        controls: false,
        seek: true
      },
      vimeo: {
        autoplay: true,
        background: true,
        controls: true,
        loop: true,
        muted: true,
        portrait: false,
        texttrack: '',
        title: false
      },
      youtube: {
        autoplay: 1,
        controls: 1,
        disablekb: 0, // keyboard controls
        fs: 0, // fullscreen
        loop: 1,
        modestbranding: 1
      }
    }

    component.plyr = new Plyr(component.$plyrElem, plyrSettings)
    component.plyr.on('ready', () => {
      component.plyr.muted = true
      component.plyr.play()
    })

    component.plyr.on('playing', () => {
      component.$component.find('.ecs_hero_video').addClass('ecs_plyr_loaded')
    })
  }

  // ComponentHero.prototype.marketSelectAction = function (elem) {
  //   const val = $(elem).val()
  //   const form = $('[data-ecs-element="hero-market-search"]')
  //   const slug = form.data('ecs-market-slug')
  //
  //   form.attr('action', slug + val + '/')
  // }

  ComponentHero.prototype.init = function () {
    const component = this
    const windowMobile = window.matchMedia('(min-width: 768px)')

    // Check viewport width before loading Video or Sliders
    if (windowMobile.matches) {
      component.initVideo()
      component.initSlider()
    }

    // $('[data-ecs-market-select]').change(component.marketSelectAction($(this)))

    $('[data-ecs-market-select]').change(function () {
      const val = $(this).val()
      const element = $('[data-ecs-element="hero-market-search"]')
      const slug = element.data('ecs-market-slug')

      element.attr('action', slug + val + '/')
    })

    $(document).ready(function () {
      const val = $('[data-ecs-market-select]').val()
      const element = $('[data-ecs-element="hero-market-search"]')
      const slug = element.data('ecs-market-slug')
      const allSlug = element.data('ecs-market-slug-all')

      // if not on a property page modify form action
      if ($('[data-ecs-market-select]').length >= 1) {
        if (val) {
          element.attr('action', slug + val + '/')
        } else {
          element.attr('action', slug + allSlug)
        }
      }

    })
  }

  return ComponentHero
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.ComponentHero = new COMPONENTS.ComponentHero()
  COMPONENTS.ComponentHero.init()
})
